import React from 'react'

function ConditionsForContributorsES() {
  return (
    <>
      <p className="heading-1">
        Condiciones generales de uso (CGU) Skeepers Influence
      </p>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">1. Objeto</p>
        <p>
          Las presentes condiciones generales de utilización (las «CGU») tienen
          por objetivo regir el uso del sitio web{' '}
          <a
            href="http://app.im.skeepers.io/"
            target="_blank"
            rel="noopener noreferrer"
          >
            http://app.im.skeepers.io/
          </a>{' '}
          editado por la empresa Skeepers, así como los términos y condiciones
          en las que se proporcionan los distintos servicios que se ofrecen en
          este sitio web. La navegación por el Sitio web tal y como se define a
          continuación supone la total aceptación expresa y sin reservas por
          parte del Creator de las presentes GCU.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">2. Definiciones</p>
        <p>
          Los términos empleados a continuación con una mayúscula tienen la
          definición que se les atribuye a continuación:
        </p>
        <div className="definition">
          <p>CGU</p>
          <p>Se refiere a las condiciones generales de uso presentes;</p>
        </div>
        <div className="definition">
          <p>Cliente</p>
          <p>
            Se refiere a la empresa, el fabricante o la entidad que comercializa
            el producto/servicio bajo una marca, objeto o Contenido;
          </p>
        </div>
        <div className="definition">
          <p>Contenido</p>
          <p>
            Se refiere a los textos, incluidos las opiniones, imágenes, sonidos,
            vídeos, fotografías, dibujos, avatares y en general cualquier
            publicación visual, textual o gráfica que represente o que haga
            referencia a los productos o servicios difundidos por un Creator en
            el marco de la Solución.
          </p>
        </div>
        <div className="definition">
          <p>Creator</p>
          <p>
            Persona registrada con anterioridad y que acceda a la plataforma de
            Skeepers para generar Contenidos. (IM y CV).
          </p>
        </div>
        <div className="definition">
          <p>Identificadores</p>
          <p>
            Se refiere al nombre de Creator y a la contraseña que permiten al
            Creator acceder al Sitio web;
          </p>
        </div>
        <div className="definition">
          <p>Influencer</p>
          <p>
            Creator que ha recibido un producto gratuito para que publique un
            Contenido exclusivo en su red social (p. ej., Instagram, TikTok,
            YouTube, Pinterest, Blog...).
          </p>
        </div>
        <div className="definition">
          <p>Productos</p>
          <p>
            Se refiere a los productos y servicios comercializados por el
            Cliente;
          </p>
        </div>
        <div className="definition">
          <p>Perfil</p>
          <p>Se refiere a la interfaz del Sitio web dedicada al Creator</p>
        </div>
        <div className="definition">
          <p>Redes sociales</p>
          <p>
            Se refiere a todas las redes sociales presentes o futuras cuyos
            Contenidos pueden ser objeto de los Servicios de Skeepers, como, por
            ejemplo: YouTube, Instagram, Facebook, Twitter, Twitch, Blogs,
            TikTok, Pinterest.
          </p>
        </div>
        <div className="definition">
          <p>Servicios</p>
          <p>Se refiere a los servicios que ofrece Skeepers;</p>
        </div>
        <div className="definition">
          <p>Sitio</p>
          <p>
            Se refiere al sitio web accesible en la dirección{' '}
            <a
              href="http://app.im.skeepers.io/"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://app.im.skeepers.io/
            </a>{' '}
            ;
          </p>
        </div>
        <div className="definition">
          <p>Skeepers</p>
          <p>
            Se refiere a la entidad jurídica identificada en el Aviso legal del
            Sitio web;
          </p>
        </div>
        <div className="definition">
          <p>Tester</p>
          <p>
            Creator que ha recibido un producto gratuito para que publique un
            Contenido exclusivo en su red social (p. ej., Instagram, TikTok,
            YouTube, Pinterest, Blog...).socios.
          </p>
        </div>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          3. Descripción de los Servicios
        </p>
        <p>Skeepers propone a los Creators los siguientes Servicios:</p>
        <ul className="paragraph-2">
          <li>
            El acceso al Sitio web por parte de los Creators (incluyendo la
            visualización de las estadísticas, los intercambios y los
            emparejamientos con los Productos y los Clientes);
          </li>
          <li>El envío de Productos o de servicios relacionados.</li>
        </ul>
        <p>
          Los servicios ofrecidos por Skeepers se proponen a los Creators de
          manera gratuita.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">4. Acceso a los Servicios</p>
        <p>
          Skeepers no garantiza que el Sitio web sea accesible de forma
          continua. Skeepers se reserva el derecho a modificar, suspender o
          suprimir total o parcialmente el Sitio web y la información que
          contiene en cualquier momento y sin previo aviso. En consecuencia,
          Skeepers no será responsable de cualquier daño, probado o alegado,
          sufrido directa o indirectamente por cualquier Creator, vinculado a la
          conexión, la consulta o el uso de la información proporcionada en el
          Sitio web.
        </p>
        <p>
          Para acceder a los Servicios, los Creators deben conectarse al Sitio
          web con sus Identificadores bajo las condiciones descritas a
          continuación.
        </p>
        <p>
          De forma general, todo incumplimiento de las estipulaciones de las
          presentes CGU podrá entrañar, inmediatamente y sin notificación
          previa, la supresión o suspensión de la cuenta de Creator, sin
          perjuicio de la demanda por daños y perjuicios que pueda presentar
          Skeepers.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">5. Cuenta personal Skeepers</p>
        <p className="tc-neutral900 ml-16">1/ El registro</p>
        <p>
          El registro en el Sitio web para crearse una cuenta personal se
          efectúa a través de la interfaz dedicada a los Creators en el Sitio
          web, cumplimentando todos los datos identificados como obligatorios.
          El Creator puede también facilitar datos facultativos, por ejemplo, y
          sin que esta lista sea exhaustiva: sus marcas favoritas, sus
          intereses, etc. -
        </p>
        <p>
          Skeepers se reserva el derecho a rechazar todo registro incompleto o
          no conforme.
        </p>
        <p>El Creator garantiza a Skeepers que:</p>
        <ul className="paragraph-2">
          <li>
            El Creator tiene al menos dieciséis (16) años. Si no ha alcanzado la
            mayoría de edad en su país de residencia, deberá obtener el
            consentimiento parental para crearse una cuenta personal en el Sitio
            web;
          </li>
          <li>
            El Creator no trabaja ni ha trabajado para Skeepers ni trabaja para
            una agencia de medios o una agencia publicitaria asociada a
            Skeepers;
          </li>
        </ul>
        <p>
          En calidad de Influencer, el Creator debe tener como mínimo una cuenta
          en una Red social, visible al público y que cuente con un número
          mínimo de seguidores (este requisito es necesario para cada Red social
          mencionada en el Sitio web en el momento del registro); y debe
          mantenerse durante toda la duración de su registro en el Sitio web.
        </p>
        <p>
          Skeepers se reserva el derecho, en todo momento y durante todo el
          periodo del registro, a verificar que la Cuenta de la Red social del
          Influencer reúna adecuadamente los criterios mencionados
          anteriormente. En el hipotético caso en que la Cuenta de la Red social
          dejara de cumplir los criterios mencionados más arriba, Skeepers se
          reserva el derecho a desactivar o cancelar la cuenta personal del
          Creator en el Sitio web.
        </p>
        <p>
          El Creator se compromete a no incrementar artificialmente de manera
          automática o manual, él mismo a través de un tercero, el número de
          visitas, de impresiones o de clics asociados a los Contenidos que
          publique en su Cuenta de la Red social, ni a incitar a otras personas
          a hacerlo.
        </p>
        <p>
          El Creator garantiza que la información suministrada para la creación
          de su cuenta es exacta, sincera y personal. El Creator se compromete a
          actualizar con regularidad sus datos para informar a Skeepers sobre su
          perfil personal y poder beneficiarse de los Servicios mejor adaptados
          que ofrece Skeepers. Skeepers se reserva el derecho a eliminar
          cualquier cuenta, en particular aquellas cuyos datos sean incorrectos
          o cuya dirección, principalmente postal, no permitiera el envío ni la
          utilización normal de los Productos. El registro del Creator conlleva
          automáticamente la creación de una cuenta y de un perfil a nombre del
          seudónimo que use en las redes sociales, además de un espacio para
          información relativa al Creator que estará accesible particularmente
          para los Clientes en caso de emparejamiento.
        </p>

        <p className="tc-neutral900 ml-16">2/ La cuenta personal</p>
        <p>
          Tras registrarse en el Sitio web como se describe anteriormente, el
          Creator finaliza la creación de su cuenta proporcionando unos
          Identificadores que el Creator puede modificar en su cuenta. La cuenta
          es accesible bajo las mismas condiciones que el Sitio web. Los
          Identificadores son personales y no pueden comunicarse a ni ser
          explotados por terceros, so pena de que la cuenta sea suspendida o
          eliminada. Cualquier sospecha de divulgación, ya sea intencionada o
          no, de los Identificadores y de las contraseñas son responsabilidad
          única y personal del Creator. Skeepers no se hace responsable de
          ningún uso ilícito o fraudulento de los Identificadores y de las
          contraseñas, así como de las diversas herramientas puestas a
          disposición del Creator.
        </p>
        <p>
          El Creator también puede ver en su cuenta sus créditos, los Productos
          pedidos, pendientes, los Contenidos en proceso y anteriores.
        </p>
        <p>
          La creación de una cuenta personal no da el derecho al Creator a
          beneficiarse automáticamente de todos los Servicios y no garantiza el
          «emparejamiento» con los Productos, Skeepers se reserva la elección de
          los Testeres beneficiarios de los Productos, y el Cliente la de los
          Influencers beneficiarios de los Productos.
        </p>
        <p>
          El Creator puede solicitar a Skeepers la rescisión de su cuenta en
          cualquier momento por escrito y previo aviso (basta con un correo
          electrónico) de quince (15) días.
        </p>

        <p className="tc-neutral900 ml-16">3/ El Perfil</p>
        <p>
          En la creación de la cuenta de Skeepers en el Sitio web se genera un
          Perfil que permite identificar al Creator y que este se beneficie de
          los Servicios. Desde el momento en que se crea el Perfil personal, el
          Creator se identifica en el Sitio web con el seudónimo y el avatar que
          utiliza en las redes sociales que indique el Creator en el Sitio web.
          El Perfil también contiene los Contenidos anteriores descargados
          automáticamente en el Sitio web, con el consentimiento del Creator.
        </p>
        <p>
          Según los datos proporcionados por el Creator al registrarse, su
          Perfil es susceptible de corresponder a Productos. En tal caso, el
          emparejamiento entre el Creator y los Productos es posible. Sin
          embargo, Skeepers se reserva el derecho a limitar este emparejamiento
          según sus propios criterios de selección.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">6.  Uso de los Servicios</p>
        <p className="tc-neutral900 ml-16">
          1/ Pedidos de Productos y publicación de Contenidos
        </p>
        <p>
          En su cuenta, el Creator puede visualizar los Productos propuestos por
          los Clientes, susceptibles de «emparejamiento» con su Perfil. La
          información relativa al precio de los Productos y las condiciones que
          se deben cumplir para difundir el Contenido (por ejemplo, y sin que
          esta sea una lista exhaustiva: mencionar al Cliente, adjuntar un
          hashtag...) igualmente se especifican por parte del Cliente durante la
          descripción de los Productos.
        </p>
        <p>
          Si al Creator le gusta una oferta, puede seleccionar la pestaña
          «Pedir» para recibir el Producto. Antes de confirmar el pedido, debe
          marcar una casilla para especificar que está al tanto de las
          condiciones relativas al Contenido que deberá publicar.
        </p>
        <p>
          Tras haber confirmado el pedido, el Creator recibe el Producto sin
          gastos (ya sea directamente del Cliente o de Skeepers).
        </p>
        <p>
          Una vez que el Producto se ha recibido y probado, el Creator crea un
          Contenido respetando las condiciones fijadas por el Cliente en la
          descripción del Producto, las cuales ha aceptado.
        </p>
        <p>
          El Influencer comparte el enlace de su Contenido en el Sitio web en un
          plazo máximo de una hora tras la publicación de su Contenido en sus
          Redes sociales. El Contenido deberá publicarse en «modo público» y
          deberá permanecer accesible durante al menos treinta (30) días a
          partir de su publicación en las Redes sociales salvo en el caso de un
          cambio de opinión sobre el Producto, el cual deberá notificarse con
          anterioridad por correo electrónico a Skeepers.
        </p>
        <p>
          A continuación, el Creator marca una casilla para aceptar el Contrato
          de cesión de derechos («Skeepers Community Agreement»).
        </p>
        <p>
          Skeepers se reserva el derecho a controlar los Contenidos cuando el
          Creator los publique en el Sitio web con el fin de verificar que sean
          conformes a las condiciones establecidas por el Cliente por una parte,
          y a las CGU de Skeepers, así como al Contrato de cesión de derechos
          por otra parte.
        </p>
        <p>
          En el caso de que el Contenido no sea conforme, puede que no se
          difunda en el Sitio web. Además, Skeepers podrá (i) notificar al
          Creator sobre esta falta de conformidad y pedirle que realice los
          cambios necesarios para que el Contenido sea conforme a las
          condiciones establecidas por el Cliente, a las CGU de Skeepers y al
          Contrato de cesión de derechos o (ii) desactivar o rescindir la cuenta
          del Creator.
        </p>
        <p>
          En cuanto a las opiniones de Testeres por escrito, el Tester redacta
          su Contenido en el Sitio web y, una vez validado por Skeepers, el
          Creator copia el Contenido en el sitio web del Cliente en un plazo de
          una hora tras la validación.
        </p>

        <p className="tc-neutral900 ml-16">
          2/ Imagen del Cliente y de los Productos
        </p>
        <p>
          La contrapartida de los Servicios y en particular la recepción de los
          Productos, es obligación del Creator publicarlas en un Contenido que
          cumpla las condiciones publicadas por el Cliente y que han sido
          aceptadas. En su defecto, Skeepers se reserva el derecho a limitar o a
          suspender su acceso a sus Servicios o a eliminar sus Identificadores.
        </p>
        <p>
          El Creator se compromete a respetar los Productos y la imagen de la
          marca del Cliente. Además, el Creator se compromete en todo momento a:
        </p>
        <ul className="paragraph-2">
          <li>
            Respetar las leyes y reglamentos en vigor aplicables a los Clientes
            y a los Productos y a no vulnerar los derechos de terceros o el
            orden público;
          </li>
          <li>
            No revender u obtener beneficio de manera alguna de los Productos
            obtenidos durante al menos 2 años a partir de la recepción o del
            acceso al Producto;
          </li>
          <li>
            No recibir suma dineraria u otra contrapartida por evaluar los
            Productos (salvo mención contraria por parte de Skeepers) y no
            ponerse en contacto con los Clientes para otra cosa que no sea
            evaluar sus Productos de acuerdo con las clausulas presentes;
          </li>
          <li>
            Obrar, comunicar, expresarse y escribir en relación al Cliente o los
            Productos con juicio, cortesía y respeto hacia los demás en los
            comentarios, apreciaciones e intercambios que pueda escribir y
            difundir en las redes sociales;
          </li>
          <li>
            Colaborar con Skeepers proporcionándole toda la información
            necesaria para la correcta ejecución de los Servicios;
          </li>
          <li>
            Respetar las condiciones establecidas por el Cliente en la
            descripción del Producto en el Sitio web;
          </li>
          <li>
            A indicar que se trata de un contenido en colaboración con una
            marca, por lo tanto, que el Contenido o la relación con el Cliente
            entra en los criterios de la publicidad digital o de la comunicación
            comercial de acuerdo con la definición de la ARPP.
          </li>
        </ul>
        <p>
          Por lo tanto, el Creator tiene prohibido divulgar, incluyendo, entre
          otros:
        </p>
        <ul className="paragraph-2">
          <li>
            Contenidos pornográficos, obscenos, indecentes, chocantes o no aptos
            para un público familiar, difamatorios, injuriosos, violentos,
            racistas, xenófobos o revisionistas,
          </li>
          <li>Contenidos ilícitos </li>
          <li>Contenidos que atenten contra la imagen de un tercero</li>
          <li>
            Contenidos engañosos, falsos o que promuevan o propongan actividades
            ilícitas, fraudulentas o engañosas, los Contenidos nocivos para los
            sistemas informáticos de terceros (como virus, gusanos, troyanos,
            etc.), y
          </li>
          <li>
            Más generalmente, los Contenidos susceptibles de vulnerar los
            derechos de terceros, de ser perjudiciales para terceros, o de
            comprometer la responsabilidad de Skeepers o del Cliente de alguna
            manera y en cualquier forma que sea. Con este fin, el Creator se
            compromete particularmente a no mencionar o representar cualquier
            otra marca o logotipo, y eso incluye la ropa, que no sean las marcas
            de los Productos enviados por el Cliente. Asimismo, el Creator se
            compromete a utilizar solo música sin derechos en su Contenido. El
            Creator se compromete también a no incluir ni mostrar a niños que no
            sean los suyos ni a ningún adulto que no sepa o que no haya dado su
            consentimiento para que se publique el vídeo;
          </li>
        </ul>
        <p>
          Cuando el Contenido o la relación con el Cliente entre en los
          criterios de la publicidad digital o de la comunicación comercial como
          recoge la ARPP, o cuando el Cliente lo exija, el Creator deberá
          incluir en cada Contenido un anuncio claro y unívoco de que ha
          recibido los Productos evaluados gratuitamente del Cliente a través de
          Skeepers, incluyendo:
        </p>
        <ul className="paragraph-2">
          <li>
            En YouTube:
            <ul className="paragraph-2">
              <li>
                Al principio del vídeo: una alocución verbal, fácilmente audible
                y comprensible por los Creators, sobre todo que sea lo
                suficientemente lenta y con palabras que pueda comprender la
                audiencia. Si el vídeo dura más de diez minutos, el Creator
                deberá repetir el discurso al final del vídeo;
              </li>
              <li>
                En la sección «Acerca de nosotros»: un texto explicativo claro e
                inequívoco.
              </li>
            </ul>
          </li>
          <li>
            En Instagram:
            <ul className="paragraph-2">
              <li>
                Si el contenido es una foto: un texto claro e inequívoco
                disponible en las tres primeras líneas de la descripción de la
                foto.
              </li>
              <li>
                Si el Contenido es una story: un hashtag claro e inequívoco
                publicado para cada story.
              </li>
            </ul>
          </li>
          <li>
            En el sitio web del Cliente: un texto claro e inequívoco disponible
            en las tres primeras líneas del comentario del Creator relativo al
            producto del Cliente.
          </li>
          <li>
            El Contenido debe reflejar la opinión sincera y la experiencia
            personal del Creator en base a su uso real del Producto. El Creator
            se compromete a informar a Skeepers inmediatamente si su opinión
            sobre dicho Producto cambia y a retirar el Contenido correspondiente
            inmediatamente.
          </li>
          <li>
            El Creator se compromete a no realizar afirmaciones científicas o
            sobre el rendimiento del Producto (como «¡reduce las arrugas!» o
            «¡me mantiene hidratado todo el día!»). El Creator debe concentrarse
            en lo que le gusta o no del Producto, desde su punto de vista
            personal
          </li>
        </ul>
        <p>
          Toda vulneración de las estipulaciones del presente artículo y más
          generalmente las que se encuentran en las CGU podrán entrañar
          inmediatamente y sin notificación previa la supresión o suspensión de
          la cuenta de Creator, sin perjuicio de toda demanda por daños y
          perjuicios que pueda interponer Skeepers.
        </p>
        <p>
          Además, Skeepers o el Cliente también pueden solicitar al Creator que
          retire el Contenido en cuestión en caso de no respetar las reglas y
          principios establecidos anteriormente, a lo cual se compromete de
          forma inmediata tras recibir la solicitud.
        </p>
        <p>
          Cualquier Producto recibido podrá ser utilizado únicamente por el
          Creator. El Creator se abstendrá de venderlo. El Creator podrá dar o
          regalar el Producto a un tercero después de haberlo probado y de haber
          publicado un Contenido conforme a las presentes CGU.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          7. Cesión de los derechos de uso del Contenido y autorización de
          derecho a la imagen
        </p>
        <p>
          La publicación del Contenido en el Sitio web por parte del Creator
          implicará de forma concomitante la conclusión por parte del Creator y
          de Skeepers de un Contrato de cesión de derechos sobre el Contenido
          («Skeepers Community Agreement») creado por el Creator, de este modo
          para la cesión de sus derechos de imagen accesible desde el siguiente
          enlace:{' '}
          <a
            href="https://app.im.skeepers.io/community-agreement"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/community-agreement
          </a>
        </p>
        <p>
          Si el Creator se niega a firmar el susodicho Contrato de cesión de
          derechos, este no podrá publicar su Contenido y deberá devolver el
          Producto recibido al remitente.
        </p>
        <p>
          La opinión del cliente escrita por el Creator es similar a un
          testimonio, siempre se refiere a una experiencia de consumo y es
          meramente informativa para futuros Testeres. Por consiguiente,
          Skeepers y sus socios pueden utilizar, reproducir, publicar, poner a
          disposición y traducir libremente el contenido de las opiniones de los
          clientes en todo el mundo y en cualquier medio de comunicación o
          soporte.
        </p>
        <p>
          En la fecha de aceptación de las presentes CGU, el Creator no ve
          ninguna reticencia o reserva a las disposiciones del presente
          artículo. Reconoce expresamente que, si no está dispuesto a firmar el
          Contrato de cesión de derechos, se abstendrá de pedir un Producto en
          el Sitio web, ya que la ausencia de cesión de los derechos sobre la
          propiedad intelectual y del derecho a la imagen relativos al Contenido
          constituiría una pérdida de tiempo para Skeepers.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">8. Descarga de los Contenidos</p>
        <p>
          El cliente puede descargar el Contenido en cuestión de forma no
          exclusiva con el fin de reproducir, representar y sublicenciarlo y, en
          particular, incluirlo en cualquier soporte. El Cliente también se
          beneficia de la autorización para utilizar las imágenes de las
          personas representadas en estos Contenidos identificados por el
          Cliente en el momento de su solicitud. El Creator cede a Skeepers los
          derechos citados anteriormente a través del Contrato de cesión de
          derechos citado anteriormente. Skeepers concede los susodichos
          derechos al Cliente mediante la concesión de una licencia no
          exclusiva.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">9. Garantía</p>
        <p>
          El Creator declara y garantiza que es el propietario de los Contenidos
          (incluyendo los derechos que les son propios como los derechos de
          imagen) en plena propiedad o que el Creator dispone de todos los
          derechos y permisos necesarios para la explotación y difusión del
          Contenido y que no existe ningún acuerdo o derecho que pudiera
          obstaculizar la presente garantía para la cesión o el permiso de
          explotación de la imagen y de los Contenidos.
        </p>
        <p>
          En el caso de la imagen de los niños menores de seis años en las
          plataformas en línea y los subsiguientes decretos de aplicación, los
          representantes legales de los niños menores de seis años, quedan
          obligados a solicitar el permiso necesario frente a la autoridad
          administrativa competente. Skeepers se exonera de toda responsabilidad
          en caso de que no se obtenga dicho permiso por parte de los
          representantes jurídicos. El Cliente puede, en todo momento, pedir a
          los representantes jurídicos que se verifique la autorización
          entregada, que deberán entonces enviarle desde la primera solicitud. A
          este respecto, los trámites a respetar se detallan en el sitio web
          oficial de la administración francesa.
        </p>
        <p>
          Asimismo, el Creator garantiza que estos Contenidos no atentan contra
          el orden público, contra los buenos modales o los derechos de
          terceros, no infringen ninguna disposición legislativa o reglamentaria
          y, más generalmente, no son de ninguna forma susceptibles de poner en
          riesgo la responsabilidad civil o penal de Skeepers o del Cliente.
        </p>
        <p>
          A consecuencia de todo lo anterior, el Creator garantiza a Skeepers y
          al Cliente contra toda acción, reclamación, reivindicación, desalojo
          del tipo que sea, por parte de toda persona que invoque el no
          cumplimiento de la reglamentación aplicable, un derecho de propiedad
          intelectual al que los Contenidos pudieran o hubieran podido vulnerar,
          un acto de competencia desleal o parasitaria, una vulneración del
          orden público, a las buenas maneras o a los derechos de terceros y
          particularmente tendentes a prohibir o restringir su utilización e
          indemnizará por consiguiente a Skeepers y al Cliente por todas las
          consecuencias que pudieran resultar de un incumplimiento de la
          presente garantía (particularmente de todas las pérdidas, daños y
          perjuicios, de los gastos y costes incluidos, particularmente, de los
          gastos judiciales y los honorarios de los abogados).
        </p>
        <p>
          Skeepers no hace un seguimiento del Sitio web, pero se reserva el
          derecho de retirar cualquier Contenido que contravenga las CGU o que
          no respete la ley aplicable, incluidos aquellos que violen un derecho
          a la propiedad intelectual, a partir de cuando Skeepers haya tenido
          conocimiento del susodicho Contenido ilícito. A este efecto, cada
          Creator se pondrá en contacto con Skeepers si cree que un Contenido
          viola alguno de sus derechos o la ley aplicable, siguiendo los
          trámites impuestos por la ley en materia de demandas de retirada de
          contenido ilícito. Cuando se reciba una demanda de retirada válida de
          acuerdo con las leyes aplicables, Skeepers retirará rápidamente del
          Sitio web el contenido al que se refiera esa demanda.
        </p>
        <p>
          El Creator debe evaluar y hacerse cargo de los riesgos vinculados al
          uso de cualquier Contenido, especialmente en lo concerniente a la
          exactitud, la completitud o la utilidad de tal Contenido.
        </p>
        <p>
          El Creator reconoce y acepta que todas las preguntas, comentarios,
          sugerencias, ideas, impresiones u otras informaciones en relación a
          los Servicios (en adelante las «Propuestas»), que el Creator haga a
          Skeepers, no son confidenciales y Skeepers tiene el derecho de usar y
          difundir, sin restricciones, estas Propuestas, con cualquier fin,
          comercial u otro, sin ningún reconocimiento ni compensación alguna que
          no sean aquellas que le corresponden al Creator.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">10. Informática y libertades</p>
        <p>
          En el marco de sus actividades y de la prestación de los Servicios,
          Skeepers procesa los datos personales de los Creators según los
          términos definidos por la legislación aplicable. Los distintos
          tratamientos realizados, así como los derechos de los Creators, se
          describen en la política de confidencialidad de Skeepers accesible en
          su sitio web desde el siguiente enlace:{' '}
          <a
            href="https://app.im.skeepers.io/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/privacy
          </a>
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">11. Cookies</p>
        <p>
          Durante la visita al Sitio web, las cookies pueden quedar depositadas
          en el ordenador, el móvil o la tablet del Creator. La utilización de
          algunas cookies necesita del consentimiento previo del Creator. El
          Creator encontrará la información apropiada sobre las cookies
          utilizadas en el presente sitio web haciendo clic aquí:{' '}
          <a
            href="https://app.im.skeepers.io/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.im.skeepers.io/privacy
          </a>
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          12. Propiedad intelectual de los elementos del Sitio web
        </p>
        <p>
          El conjunto de elementos editados en el Sitio web, como los sonidos,
          las imágenes, las fotos, los vídeos, los textos, las animaciones, los
          programas, el diseño gráfico, las utilidades, las bases de datos, los
          programas y las demás tecnologías subyacentes, están protegidas por
          las disposiciones del Código de propiedad intelectual, que afectan a
          Skeepers o son el objeto de una licencia concedida a Skeepers. Todo
          signo distintivo que figure en el Sitio web, particularmente las
          razones sociales, las marcas y los logotipos, son marcas propiedad de
          Skeepers o de terceros o colaboraciones, particularmente las de los
          Clientes cuyas ofertas se presentan en el Sitio web. Toda reproducción
          total o parcial, modificación o utilización de las marcas,
          ilustraciones, imágenes y logotipos, para cualquier propósito y en el
          soporte que sea, sin permiso expreso y previo del titular de los
          derechos, está estrictamente prohibida y constituirá una infracción
          sancionada por el Código de la propiedad intelectual. El Creator se
          compromete a una utilización del Sitio web y de su contenido en el
          marco de la más estricta privacidad. La utilización con fines
          comerciales está estrictamente prohibida. El Creator solicitará
          autorización previa de Skeepers para cualquier reproducción,
          publicación, y copia de distintos contenidos.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">13. Devoluciones y enlaces</p>
        <p>
          Los enlaces hipertextuales que se ponen a disposición del Creator
          enlazan con los sitios web asociados o con los sitios web de terceros.
          En la medida en que Skeepers no puede controlar esos sitios web,
          Skeepers se libera de toda responsabilidad en cuanto a la información
          contenida en esos sitios web. Skeepers no será responsable
          particularmente de las modificaciones o actualizaciones de esos sitios
          web o de cualquier disfuncionalidad que contengan. Skeepers no puede,
          en ningún caso, ser tenida por responsable de los daños directos o
          indirectos ligados a la navegación o a la descarga a través de los
          hiperenlaces publicados en el Sitio web.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">14. Responsabilidad</p>
        <p>
          El uso del Sitio web implica el conocimiento y la aceptación por parte
          del Creator de las características y los límites de Internet y de las
          tecnologías vinculadas. Skeepers no se hace responsable de cualquier
          daño resultante de una conexión al Sitio web que el Creator realice
          bajo su exclusiva responsabilidad. A este respecto, Skeepers declina
          toda responsabilidad en particular en caso de uso indebido o incidente
          relacionado con el uso del dispositivo para conectarse al Sitio web,
          el acceso a Internet, el mantenimiento o el mal funcionamiento de los
          servidores, de la línea telefónica o cualquier otra conexión de tipo
          telefónico, y del envío de formularios a una dirección errónea o
          incompleta, errores informáticos de cualquier tipo o defectos
          comprobados en el Sitio web. Además, Skeepers hará todo lo posible por
          proporcionar información precisa y actualizada en el Sitio web. Sin
          embargo, Skeepers no se hace responsable de la información inexacta u
          omisiones en el Sitio web.
        </p>
        <p>
          Skeepers solo será responsable de los daños directos resultantes de la
          utilización del Sitio web y, en cualquier caso, dado que el acceso al
          Servicio es gratuito, su responsabilidad se limitará a la suma de 100
          €. En consecuencia, Skeepers declina toda responsabilidad y no podrá
          ser considerada responsable de cualquier daño indirecto de cualquier
          tipo, originado por una causa externa a su Sitio web, como, entre
          otros: originados por el uso o la recepción de un Producto recibido
          por el Creator, derivados de o relacionados con Contenidos creados por
          el Creator, derivados de o relacionados con la relación entre Cliente
          y Creator, etc.
        </p>
        <p>
          Skeepers recuerda a los Creators que son susceptibles de tener
          obligaciones fiscales (TVA, impuestos, etc.) y sociales (URSSAF, etc.)
          relativos a sus actividades cuando tienen toda la responsabilidad. Las
          iniciativas a realizar para cumplir las exigencias legislativas y
          reglamentarias de este título, que dependen de distintos criterios
          según el caso particular del Creator.
        </p>
        <p>
          Además de las garantías previstas en este documento, el Creator
          garantiza a la empresa Skeepers la protección contra quejas,
          reclamaciones, acciones legales o demandas que Skeepers pueda sufrir
          como consecuencia de la violación, por parte del Creator, de
          cualquiera de sus obligaciones o garantías en virtud de los términos
          de estas condiciones generales. El Creator se compromete a indemnizar
          a Skeepers por cualquier perjuicio que pueda sufrir y pagar todos los
          gastos, cargos o condenas que pueda tener que soportar como
          consecuencia de ello.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">
          15. Aceptación de las condiciones de Uso de las Redes sociales
        </p>
        <p>
          Skeepers utiliza la API de YouTube en particular para autentificar y
          vincular el canal de YouTube del Creator a su perfil en el Sitio web.
          Por lo tanto, el Creator, al utilizar el Sitio web, acepta
          expresamente las condiciones de uso de YouTube disponibles en la
          siguiente dirección URL:{' '}
          <a
            href="https://www.youtube.com/t/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.youtube.com/t/terms
          </a>
        </p>
        <p>
          Del mismo modo, el Creator se compromete a aceptar y respetar las
          condiciones de uso de cada Red social que utilice para publicar
          Contenido.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">16. Disposiciones varias</p>
        <p>
          Skeepers se reserva el derecho de modificar en cualquier momento las
          presentes CGU. Un mensaje en forma de ventana emergente en el Sitio
          web informará a los Creators de la actualización de las CGU.
          Recomendamos al Creator que consulte de forma regular las CGU.
        </p>
        <p>
          La invalidez total o parcial de una de la disposiciones de las
          presentes CGU no invalidará las demás disposiciones.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">17. Aceptación</p>
        <p>
          La aceptación de las presentes condiciones generales se acreditará
          marcando una casilla en el formulario de registro propuesto al Creator
          al registrarse en el Sitio web con un enlace URL a las CGU. Esta
          aceptación se realiza de forma incondicional. Además, las CGU están
          disponibles en todo momento en el Sitio web.
        </p>
      </div>

      <div className="paragraph-2">
        <p className="tc-neutral900 underline">18. Derecho aplicable</p>
        <p>
          El Sitio web y las CGU están sujetos a la legislación francesa.
          Cualquier litigio relativo a la interpretación o la ejecución de estas
          CGU se someterá a la competencia de los tribunales competentes de
          Marsella.
        </p>
      </div>
    </>
  )
}

export default ConditionsForContributorsES
